import { useCallback } from 'react';
import { getScreenType } from 'utils';
import { useDispatchAction as usePageStoreDispatchAction } from 'store/pageStore/slice';
import { useEffectOnce } from './use-effect-once';

export const useUpdateWindowType = () => {
	const { setWindowType } = usePageStoreDispatchAction();

	const resizeEventHandler = useCallback(() => {
		const width = __IS_SERVER__ ? undefined : window.innerWidth;
		setWindowType(getScreenType(width));
	}, [setWindowType]);

	useEffectOnce(() => {
		resizeEventHandler();

		if (!__IS_SERVER__) {
			window.addEventListener('resize', resizeEventHandler);

			return () => {
				window.removeEventListener('resize', resizeEventHandler);
			};
		}

		return () => {};
	});
};
